"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_1 = __importDefault(require("@emotion/styled"));
var I = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-left: 4px;\n  transform: rotate(90deg);\n  transition: all 0.2s;\n\n  & svg {\n    stroke: #282a2b;\n  }\n"], ["\n  margin-left: 4px;\n  transform: rotate(90deg);\n  transition: all 0.2s;\n\n  & svg {\n    stroke: #282a2b;\n  }\n"])));
exports.NavArrow = function () { return (react_1.default.createElement(I, null,
    react_1.default.createElement("svg", { width: "8px", height: "13px", viewBox: "0 0 9 15" },
        react_1.default.createElement("defs", null),
        react_1.default.createElement("g", { strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("g", { id: "Third", transform: "translate(-1206.000000, -566.000000)", strokeWidth: "2" },
                react_1.default.createElement("polyline", { id: "Pointer---dark", transform: "translate(1210.000000, 573.500000) rotate(-90.000000) translate(-1210.000000, -573.500000) ", points: "1216.5 570.5 1210 576.5 1203.5 570.5" })))))); };
var templateObject_1;
